/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener("DOMContentLoaded", function() {
    // Function to initialize the image gallery
      
    function initImageGallery(wrapperId) {
        let currentImgIndex = 0;
        let startX = null;
        const imgElements = document.querySelectorAll(`#${wrapperId} .ProductItem__Image`);
        const imgDivs = document.querySelectorAll(`#${wrapperId} .productImgDiv`);
        const dotsWrapper = document.querySelector(`#${wrapperId} .dotNavigation`);
        const dots = [];
    
        // Hide all images besides the first one and add dot navigation elements
        imgElements.forEach((imgElement, i) => {
            if (i > 0) {
                imgElement.classList.add('disp-none');
            }
            const dot = document.createElement('li');
            dot.classList.add('dotCollection');
            if (i === currentImgIndex) {
                dot.classList.add('active');
            }
            dotsWrapper.appendChild(dot);
            dots.push(dot);
        });
        // Add click event listeners to buttons
        document.querySelector(`#${wrapperId} .btn-next`).addEventListener('click', function() {
            imgElements[currentImgIndex].classList.add('disp-none');
            imgDivs[currentImgIndex].classList.add('disp-none');
            currentImgIndex = (currentImgIndex + 1) % imgElements.length;
            imgElements[currentImgIndex].classList.remove('disp-none');
            imgDivs[currentImgIndex].classList.remove('disp-none');
        });
        
        document.querySelector(`#${wrapperId} .btn-prev`).addEventListener('click', function() {
            imgElements[currentImgIndex].classList.add('disp-none');
            imgDivs[currentImgIndex].classList.add('disp-none');
            currentImgIndex = (currentImgIndex - 1 + imgElements.length) % imgElements.length;
            imgElements[currentImgIndex].classList.remove('disp-none');
            imgDivs[currentImgIndex].classList.remove('disp-none');
        });

        // Add touch event listener for swiping
        document.querySelector(`#${wrapperId}`).addEventListener('touchstart', function(event) {
            startX = event.touches[0].clientX;
        });
    
        document.querySelector(`#${wrapperId}`).addEventListener('touchend', function(event) {
            const endX = event.changedTouches[0].clientX;
            const deltaX = endX - startX;
    
            if (Math.abs(deltaX) > 50) {
                imgElements[currentImgIndex].classList.add('disp-none');
                imgDivs[currentImgIndex].classList.add('disp-none');
                dots[currentImgIndex].classList.remove('active');
    
                if (deltaX > 0) {
                    currentImgIndex = (currentImgIndex - 1 + imgElements.length) % imgElements.length;
                } else {
                    currentImgIndex = (currentImgIndex + 1) % imgElements.length;
                }
    
                imgElements[currentImgIndex].classList.remove('disp-none');
                imgDivs[currentImgIndex].classList.remove('disp-none');
                dots[currentImgIndex].classList.add('active');
            }
        });
    }
    
    // Init image galleries for all product item wrappers
    const productItemWrappers = document.querySelectorAll('.ProductItem__Wrapper');
    productItemWrappers.forEach((wrapper) => {
        const wrapperId = wrapper.querySelector('.ProductItem__ImageWrapper').id;
        initImageGallery(wrapperId);
    });
  
    // Init image galleries for new product item wrappers loaded via AJAX
    // used MutationObserver which will observe the .ProductList div that contains all the product-item and checks if there have been added new nodes
    const productGrid = document.querySelector('.ProductList');
    const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const newProductItemWrappers = mutation.target.querySelectorAll('.ProductItem__Wrapper');
                newProductItemWrappers.forEach((wrapper) => {
                    const wrapperId = wrapper.querySelector('.ProductItem__ImageWrapper').id;
                    initImageGallery(wrapperId);
                });
            }
        });
    });

    observer.observe(productGrid, { childList: true });
});


(function() {
  const filterButton = document.querySelector('.CollectionToolbar__Item--filter');

  filterButton.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const filtersLink = document.querySelector('.cloud-search-page-controls__filters-link');
    
    filtersLink.click();
  });
})();

// collection description
  const descriptionElement = document.getElementById('collection-description');
  const toggleButton = document.getElementById('toggle-button');

  // will check if descriptionElement is present so it avoids throwing errors on collections that have empty description 
  if (descriptionElement) {
    const viewMore = toggleButton.getAttribute('data-view-more');
    const viewLess = toggleButton.getAttribute('data-view-less');
    const fullDescription = descriptionElement.innerHTML.trim();
    let isTruncated = true;

    function truncateDescription() {
      const truncatedDescription = fullDescription.substring(0, 200);
      descriptionElement.innerHTML = truncatedDescription;
    }

    function toggleDescription() {
      if (isTruncated) {
        descriptionElement.innerHTML = fullDescription;
        toggleButton.innerHTML = viewLess;
      } else {
        truncateDescription();
        toggleButton.innerHTML = viewMore;
      }
      isTruncated = !isTruncated;
    }
    
    truncateDescription();
    descriptionElement.classList.remove('hidden'); // the full description is hidden first since it would show for a split seccond the full desc until trimming it thus the class is removed here
  }


//breadcrumb history using SessionStorage

function setSessionStorage(name, value) {
  sessionStorage.setItem(name, value);
}

function getSessionStorage(name) {
  return sessionStorage.getItem(name);
}